import {
  Box,
  Button,
  Container,
  Heading,
  Text,
  VStack,
  HStack,
  useColorModeValue,
} from '@chakra-ui/react';
import { motion } from 'framer-motion';
import { FaArrowRight } from 'react-icons/fa';
import { Logo } from '../../Logo';

const MotionBox = motion(Box);

export const Hero = () => {
  const taglineColor = useColorModeValue('gray.600', 'gray.400');

  const handleSmoothScroll = (href: string) => {
    const target = document.querySelector(href);
    if (target) {
      target.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <Box
      id="hero"
      minH="100vh"
      display="flex"
      alignItems="center"
      pt={16}
      bg={useColorModeValue(
        'linear-gradient(180deg, #f7fafc 0%, #ffffff 100%)',
        'linear-gradient(180deg, #1a202c 0%, #171923 100%)'
      )}
    >
      <Container maxW="container.xl">
        <VStack spacing={8} textAlign="center">
          <MotionBox
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5 }}
          >
            <Logo h={{ base: '80px', md: '120px' }} mb={4} />
          </MotionBox>

          <MotionBox
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <Heading
              as="h1"
              size={{ base: '2xl', md: '3xl', lg: '4xl' }}
              fontWeight="bold"
              lineHeight="shorter"
              mb={4}
            >
              Engineering Solutions
              <br />
              <Text as="span" color="brand.500">
                That Scale
              </Text>
            </Heading>
          </MotionBox>

          <MotionBox
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.4 }}
            maxW="2xl"
          >
            <Text fontSize={{ base: 'lg', md: 'xl' }} color={taglineColor}>
              We build robust software systems, data pipelines, and analytics
              platforms. From concept to production, we deliver solutions that
              drive real business value.
            </Text>
          </MotionBox>

          <MotionBox
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5, delay: 0.6 }}
          >
            <HStack spacing={4} pt={4}>
              <Button
                size="lg"
                colorScheme="brand"
                rightIcon={<FaArrowRight />}
                onClick={() => handleSmoothScroll('#case-studies')}
              >
                View Our Work
              </Button>
              <Button
                size="lg"
                variant="outline"
                onClick={() => handleSmoothScroll('#contact')}
              >
                Get in Touch
              </Button>
            </HStack>
          </MotionBox>
        </VStack>
      </Container>
    </Box>
  );
};
